import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { ColorDot } from '../color-dot';
import { PanelHeader } from './panel-header';
import { PanelTabs } from './panel-tabs';

export const AppointmentDetailsPanel = () => {
  return (
    <section css={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <PanelHeader />
      <div css={contentContainer}>
        <div css={contentItemContainer}>
          <ColorDot color='#E0107B' />
          <Text size='small' weight='bold'>
            Summer Body Package Consultation
          </Text>
        </div>
        <div css={contentItemContainer}>
          <Icon name='department-small' />
          <Text size='small' weight='bold'>
            Exam Room 3
          </Text>
        </div>
        <PanelTabs />
      </div>
    </section>
  );
};

const contentContainer = css({
  flex: 1,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(3),
  gap: theme.spacing(1),
});

const contentItemContainer = css({
  border: `1px solid ${theme.colors.neutral20}`,
  borderRadius: theme.borderRadius.medium,
  padding: theme.spacing(2),
  display: 'flex',
  gap: theme.spacing(0.5),
});
